import { UseMutateAsyncFunction } from 'react-query';

import {
  ClientDepartmentStatus,
  ClientLocationStatus,
  ContentEmailSpecInput,
  ContentEmailSpecMutation,
  CreateClientDepartmentInput,
  CreateClientDisclosureInput,
  CreateClientLocationInput,
  CreateClientDepartmentMutation,
  CreateClientLocationMutation,
  UpdateClientDepartmentMutation,
  UpdateClientLocationMutation,
  UpdateClientLocationInput,
  UpdateClientDepartmentInput,
  UpdateUserSegmentInput,
  UserSegment,
} from 'api';

type DepartmentsLocationCreateAsyncFunction = UseMutateAsyncFunction<
  CreateClientDepartmentMutation | CreateClientLocationMutation,
  unknown,
  { data: CreateClientDepartmentInput | CreateClientLocationInput }
>;
type DepartmentsLocationUpdateAsyncFunction = UseMutateAsyncFunction<
  UpdateClientDepartmentMutation | UpdateClientLocationMutation,
  unknown,
  { data: UpdateClientDepartmentInput | UpdateClientLocationInput }
>;

export type EditableList = EditableListType.Departments | EditableListType.Locations;
export type IDisclosure = Partial<CreateClientDisclosureInput>;
export type ContentEmailValues = ContentEmailSpecMutation | ContentEmailSpecInput;
export type UserSegmentValues = UpdateUserSegmentInput | UserSegment;

export type ICreateDepartmentLocation = Partial<
  CreateClientDepartmentInput | CreateClientLocationInput
>;
export type IUpdateDepartmentLocation = Partial<
  UpdateClientDepartmentInput | UpdateClientLocationInput
>;

export interface IDepartmentsLocationsOptions {
  createAsyncMutation: DepartmentsLocationCreateAsyncFunction;
  updateAsyncMutation: DepartmentsLocationUpdateAsyncFunction;
  activeDepartmentStatus?: {
    department_status: ClientDepartmentStatus;
  };
  disabledDepartmentStatus?: {
    department_status: ClientDepartmentStatus;
  };
  activeLocationStatus?: {
    location_status?: ClientLocationStatus;
  };
  disabledLocationStatus?: {
    location_status?: ClientLocationStatus;
  };
}

export enum EditableListType {
  Departments = 'departments',
  Locations = 'locations',
}
